export default __webpack_public_path__ + "static/collection-2-c298e1e500cfa7552634ef385c7f0ed9.webp";